<div id="scoreCard">
  @if (chartOptions != undefined){
    <div class="score-chartWrapper">
      <apx-chart
        [series]="chartOptions.series"
        [chart]="chartOptions.chart"
        [grid]="chartOptions.grid"
        [plotOptions]="chartOptions.plotOptions"
        [labels]="chartOptions.labels"
        [stroke]="chartOptions.stroke"
        [fill]="chartOptions.fill">
      </apx-chart>
    </div>  
  }
</div>